export const PICKLIST_TYPES = {
  BARCODE: 'barcode',
  BATCH_CODE: 'batch_code',
};

export const PICKLIST_TYPE_OPTIONS = [
  { label: 'Barcode', value: PICKLIST_TYPES.BARCODE },
  { label: 'Batch Code', value: PICKLIST_TYPES.BATCH_CODE },
];

export const PICKLIST_TYPE_LABELS = {
  [PICKLIST_TYPES.BARCODE]: 'Barcode',
  [PICKLIST_TYPES.BATCH_CODE]: 'Batch Code',
};
